// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure3--figure--3kCBA","background":"Figure3--background--2w1xL"};